import { Modal } from 'antd';

// Negatif tutarlı kayıt girişinde kullanıcıdan onay ister.
// Promise<boolean> döner: kullanıcı onaylarsa true, vazgeçerse false.
// Çağıran taraf negatiflik kontrolünü kendi yapar; bu yardımcı sadece onay penceresini gösterir.
export const negatifKayitOnayi = (tur = 'kayıt') => {
  return new Promise((resolve) => {
    Modal.confirm({
      title: 'Negatif tutarlı kayıt',
      content: `Negatif tutarlı bir ${tur} kaydediyorsunuz. Devam etmek istediğinize emin misiniz?`,
      okText: 'Evet, kaydet',
      cancelText: 'Vazgeç',
      okButtonProps: { danger: true },
      onOk: () => resolve(true),
      onCancel: () => resolve(false),
    });
  });
};
